import { css } from "@emotion/react";
import { bpoints } from "../../Utils";

export function footerCSS(){
    return css`
        width: 100%;
        padding-top: 5vh;
        padding-bottom: 7vh;
        background: #0C2036;

        display: flex;
        justify-content: space-evenly;

        @media (max-width: ${bpoints.mobile.w}px){
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;

            gap: 5vh;
        }

        .First{
            align-items: center;
            gap: 3vw;

            @media (max-width: ${bpoints.mobile.w}px){
                justify-content: flex-start;
                gap: 12vw;
            }

            img{
                width: calc(2rem + 6vw);

                @media (max-width: ${bpoints.mobile.w}px){
                    width: calc(3rem + 15vw);

                }
            }

            .Text{
                position: relative;
                display: flex;
                gap: 0.5vw;
                
                @media (max-width: ${bpoints.mobile.w}px){
                    gap: 1vw;
                    margin-right: 3vw;
                }

                span{
                    font-size: calc(0.5rem + 1vw);

                    @media (max-width: ${bpoints.mobile.w}px){
                        font-size: calc(0.7rem + 2.2vw);

                    }
                }
    
                .One{
                    color: #CECECE;
                }
    
                .Two{
                    color: #34C6F1;
                }
    
                .Three{
                    color: #1FDD8F;
                }

                .RightsReserved{
                    position: absolute;
                    bottom: -8vh;
                    
                    display: flex;
                    flex-direction: column;
                    gap: 0.2rem;
                    color: #A7A9AC;



                    @media (max-width: ${bpoints.mobile.w}px){
                        display: none;
                    }

                    .Terms{
                        white-space: nowrap;
                        display: flex;
                        color: white;
                        align-items: center;
                        gap: 4%;
                        
                        font-size: calc(0.3rem + 0.5vw);
        
                        a {
                            color: inherit;
                            text-decoration: none;
                        }
                    }

                    .RightsLegend{
                        font-size: calc(0.1rem + 0.7vw);
                        white-space: nowrap;
                    }
                }

                
            }
            
        }

        .Second{
            align-items: center;

            @media (max-width: ${bpoints.mobile.w}px){
                justify-content: center;
            }
            .Line{
                background: linear-gradient(90deg, rgba(32, 75, 123, 0.00) 0%, #204B7B 19.27%, #32B8DF 48.96%, #00BA6E 80.73%, rgba(0, 186, 110, 0.00) 98.44%);
                width: 20vw;
                height: 1.6px;

                @media (max-width: ${bpoints.mobile.w}px){
                    width: 100%;
                }
            }
        }

        .Third{
            flex-direction: column;
            gap: 0.3vh;

            @media (max-width: ${bpoints.mobile.w}px){
                gap: 1vh;
            }

            .Email{
                background: linear-gradient(90deg, #34C6F1 6.22%, #1FDD8F 77.34%);
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;

                font-size: calc(0.4rem + 1vw);

                @media (max-width: ${bpoints.mobile.w}px){
                    font-size: calc(1.1rem + 1.9vw);

                }
            }

            .Telephone{
                color: #1FDD8F;
                font-weight: 600;
                font-size: calc(0.3rem + 1vw);

                @media (max-width: ${bpoints.mobile.w}px){
                    font-size: calc(1rem + 1.3vw);
                }
            }

            .Cities{
                color: white;
                margin-top: 0.8rem;
                font-size: calc(0.2rem + 0.7vw);

                @media (max-width: ${bpoints.mobile.w}px){
                    font-size: calc(0.5rem + 1.2vw);
                    margin-top: 1rem;

                }
                @media (max-width: 760px){
                    max-width: 200px;
                }
            }
            .CitiesDirection{
                color: white;
                margin-top: 0.8rem;
                font-size: calc(0.2rem + 0.7vw);
                max-width: 300px;   
                @media (max-width: ${bpoints.mobile.w}px){
                    font-size: calc(0.5rem + 1.2vw);
                    margin-top: 1rem;

                }
                @media (max-width: 760px){
                    max-width: 200px;
                }
                @media (max-width: 650px){
                    max-width: 80%
                }
            }
            .RightsReserved{
                display: none;
                white-space: nowrap;
                
                color: #A7A9AC;

                @media (max-width: ${bpoints.mobile.w}px){
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }

                .RightsLegend{
                    font-size: calc(0.5rem + 1.5vw);
                }

                .Terms{
                    display: flex;
                    color: white;
                    align-items: center;
                    gap: 4%;
                    
                    font-size: calc(0.4rem + 2vw);
    
                    a {
                        color: inherit;
                        text-decoration: none;
                    }
                }

                margin-top: 3vh;
            }

        }

        .Block{
            display: flex;

            @media (max-width: ${bpoints.mobile.w}px){
                width: 85%;
            }
        }
    `;
}